import React, { Component } from "react";
import { Row, Col, Carousel, Button, Table } from "react-bootstrap";
import SignalDispatcher from "../utils/signalDispatcher";
import Cart from "../models/cart-model";
import EventModel from "../models/event-model";
import signalDispatcherInstance from "../utils/signalDispatcher";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

interface CartEventProps {
    events: Array<EventModel>;
    hidden?: boolean;
}

interface CartEventState {
    events: Array<EventModel>;
    hidden?: boolean;
    translations: Record<string, any>;
}

class CartTicket extends Component<CartEventProps, CartEventState, EventModel> {
    constructor(props: CartEventProps) {
        super(props);
        this.state = {
            events: this.props.events,
            hidden: this.props.hidden ? this.props.hidden : false,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private formatPrice(price: number) {
        return price && price !== null ? price.toLocaleString() : '';
    }

    private deleteEvent(event: EventModel) {
        const updatedEvents = this.state.events.filter(e => e.id !== event.id);
        this.setState({ events: updatedEvents });
        signalDispatcherInstance.emit('updateCartTicket', updatedEvents);
    }

    private getEventPrice(event: EventModel) {
        let totalPrice = 0;
        if (event && event.mealsList && event.mealsList.length > 0) {
            event.mealsList.forEach(meal => {
                if (meal.price_huf && meal.quantity) {
                    totalPrice += meal.price_huf * meal.quantity;
                }
            });
        }
        return totalPrice;
    }

    private getAgesPrice(event: EventModel) {
        let totalPrice = 0;
        if (event && event.agePrices) {
            if (event?.ages?.adult && event.agePrices.adult) {
                totalPrice += event.ages.adult * event.agePrices.adult;
            }
            if (event?.ages?.junior && event.agePrices.junior) {
                totalPrice += event.ages.junior * event.agePrices.junior;
            }
            if (event?.ages?.child && event.agePrices.child) {
                totalPrice += event.ages.child * event.agePrices.child;
            }
        }
        return totalPrice;
    }

    private incrementTicket(event: EventModel, type: string) {
        const updatedEvents = this.state.events.map(e =>
            e.id === event.id ? { ...e, quantity: e.quantity + 1 } : e
        );
        updatedEvents.forEach(ev => {
            if (ev.id === event.id && ev.ages) {
                if (type === 'adult') {
                    ev.ages.adult = ev.ages.adult + 1;
                } else if (type === 'junior') {
                    ev.ages.junior = ev.ages.junior + 1;
                } else if (type === 'child') {
                    ev.ages.child = ev.ages.child + 1;
                }
            }
        });
        this.setState({ events: updatedEvents });
        let currentCount = 0;
        updatedEvents?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartEvent', updatedEvents);
    }

    private decrementTicket(event: EventModel, type: string) {
        const updatedEvents = this.state.events.map(e =>
            e.id === event.id && e.quantity > 1 ? { ...e, quantity: e.quantity - 1 } : e
        );
        updatedEvents.forEach(ev => {
            if (ev.id === event.id && ev.ages) {
                if (type === 'adult') {
                    ev.ages.adult = ev.ages.adult > 0 ? ev.ages.adult - 1 : 0;
                } else if (type === 'junior') {
                    ev.ages.junior = ev.ages.junior > 0 ? ev.ages.junior - 1 : 0;
                } else if (type === 'child') {
                    ev.ages.child = ev.ages.child > 0 ? ev.ages.child - 1 : 0;
                }
            }
        });
        this.setState({ events: updatedEvents });
        let currentCount = 0;
        updatedEvents?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartEvent', updatedEvents);
    }

    private deleteTicket(event: EventModel) {
        const updatedEvents = this.state.events.filter(e => e.id !== event.id);
        this.setState({ events: updatedEvents });
        let currentCount = 0;
        updatedEvents?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartEvent', updatedEvents);
    }

    render() {
        return (
            <div>
                {this.state.events.map((event, index) => (
                <Table key={index} responsive>
                {event && event.ages && (event.ages.adult > 0 || event.ages.junior > 0 || event.ages.child > 0) && 
                <>
                    <thead className="oc-ticket-items">
                        <tr>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'SERVICE_NAME')[0].setting_value_text}</th>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'PICKED_DATE')[0].setting_value_text}</th>
                            <th className="toRightPos">{this.state.translations.filter((item: any) => item.setting_name === 'AMOUNT')[0].setting_value_text}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={'fr'+index}>
                            <td>{event.name}</td>
                            <td>{event.date} {event.time}</td>
                            <td className="toRightPos">{event.quantity} {this.state.translations.filter((item: any) => item.setting_name === (event.name === 'privateboat' ? 'PIECES' : 'SEATS'))[0].setting_value_text}</td>
                            <td className="toRightPos">
                                <Button hidden={this.state.hidden} variant="light" className="oc-btn oc-btn-delete" onClick={() => {this.deleteTicket(event)}}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </td>
                        </tr>
                        <tr key={'lr'+index}>
                            <th colSpan={4}>{this.state.translations.filter((item: any) => item.setting_name === 'PICKED_TICKET')[0].setting_value_text}</th>
                        </tr>
                        {event.ages && event.ages.adult > 0 &&
                        <tr key={'adult'}>
                            <td>{this.state.translations.filter((item: any) => item.setting_name === 'ADULT_TICKETS')[0].setting_value_text}</td>
                            <td>{this.formatPrice(event.agePrices?.adult ?? 0)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="toRightPos">{this.formatPrice((event.agePrices?.adult ?? 0) * event.ages.adult)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="oc-qty-col">
                                <Button variant="light" hidden={this.state.hidden} disabled={event.ages.adult === 0 ? true : false} className="oc-btn oc-btn-qty" onClick={() => {this.decrementTicket(event,'adult')}}>-</Button>
                                <input type="text" className="oc-input oc-input-count" value={event.ages.adult} readOnly />
                                <Button variant="light" hidden={this.state.hidden} className="oc-btn oc-btn-qty" onClick={() => {this.incrementTicket(event,'adult')}}>+</Button>
                            </td>
                        </tr>
                        }
                        {event.ages && event.ages.junior > 0 &&
                        <tr key={'junior'}>
                            <td>{this.state.translations.filter((item: any) => item.setting_name === 'JUNIOR_TICKETS')[0].setting_value_text}</td>
                            <td>{this.formatPrice(event.agePrices?.junior ?? 0)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="toRightPos">{this.formatPrice((event.agePrices?.junior ?? 0) * event.ages.junior)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="oc-qty-col">
                                <Button variant="light" hidden={this.state.hidden} disabled={event.ages.junior === 0 ? true : false} className="oc-btn oc-btn-qty" onClick={() => {this.decrementTicket(event,'junior')}}>-</Button>
                                <input type="text" className="oc-input oc-input-count" value={event.ages.junior} readOnly />
                                <Button variant="light" hidden={this.state.hidden} className="oc-btn oc-btn-qty" onClick={() => {this.incrementTicket(event,'junior')}}>+</Button>
                            </td>
                        </tr>
                        }
                        {event.ages && event.ages.child > 0 &&
                        <tr key={'child'}>
                            <td>{this.state.translations.filter((item: any) => item.setting_name === 'CHILD_TICKETS')[0].setting_value_text}</td>
                            <td>{this.formatPrice(event.agePrices?.child ?? 0)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="toRightPos">{this.formatPrice((event.agePrices?.child ?? 0) * event.ages.child)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                            <td className="oc-qty-col">
                                <Button variant="light" hidden={this.state.hidden} disabled={event.ages.child === 0 ? true : false} className="oc-btn oc-btn-qty" onClick={() => {this.decrementTicket(event,'child')}}>-</Button>
                                <input type="text" className="oc-input oc-input-count" value={event.ages.child} readOnly />
                                <Button variant="light" hidden={this.state.hidden} className="oc-btn oc-btn-qty" onClick={() => {this.incrementTicket(event,'child')}}>+</Button>
                            </td>
                        </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE')[0].setting_value_text}:</strong></td>
                            <td colSpan={3} className="toRightPos">
                                <strong className="oc-total-price">
                                    {this.formatPrice(this.getAgesPrice(event))} HUF <small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small>
                                </strong>
                            </td>
                        </tr>
                    </tfoot>
                </>
                }
                {event && event.mealsList && event.mealsList.length > 0 && 
                <>
                    <thead className="oc-ticket-items">
                        <tr>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'SERVICE_NAME')[0].setting_value_text}</th>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'PICKED_DATE')[0].setting_value_text}</th>
                            <th className="toRightPos">{this.state.translations.filter((item: any) => item.setting_name === 'AMOUNT')[0].setting_value_text}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={'fr'+index}>
                            <td>{event.name}</td>
                            <td>{event.date} {event.time}</td>
                            <td className="toRightPos">{event.quantity} {this.state.translations.filter((item: any) => item.setting_name === (event.name === 'privateboat' ? 'PIECES' : 'SEATS'))[0].setting_value_text}</td>
                        </tr>
                        <tr key={'lr'+index}>
                            <th colSpan={3}>{this.state.translations.filter((item: any) => item.setting_name === (event.name === 'privateboat' ? 'PICKED_PACKAGE' : 'PICKED_MENUS'))[0].setting_value_text}</th>
                        </tr>
                        {event.mealsList && event.mealsList.map((menu, mIndex) => (
                        <tr key={'mr'+mIndex}>
                            <td colSpan={2}>{menu.title}</td>
                            <td className="toRightPos">{menu.quantity} {this.state.translations.filter((item: any) => item.setting_name === (event.name === 'privateboat' ? 'PIECES' : 'MEALS'))[0].setting_value_text}</td>
                        </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE')[0].setting_value_text}:</strong></td>
                            <td colSpan={4} className="toRightPos">
                                <strong className="oc-total-price">
                                    {this.formatPrice(this.getEventPrice(event))} HUF <small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small>
                                </strong>
                            </td>
                        </tr>
                    </tfoot>
                </>
                }
                </Table>
                ))}
            </div>
        );
    }
}

export default CartTicket;